import { useLocation } from "react-router-dom"

import { Pages } from "modules/BookingCommon/common/constants"

interface LocationState {
    bookingPage?: Pages
}

export function useGetCurrentPage(): Pages | undefined {
    const location = useLocation()
    const state = location.state as LocationState | undefined
    return state?.bookingPage
}
